<template>
  <div>
    <input :id="_uid" type="checkbox" v-model="checked" @input="$emit('input', $event.target.checked)" :state="state">
    <label :for="_uid">
      <span class="on">{{ onLabel }}</span>
      <span class="off">{{ offLabel }}</span>
    </label>
  </div>
</template>

<script>
import baseInput from './_base'

export default {
  mixins: [baseInput],

  props: {
    onLabel: { type: String, default: 'Yes' },
    offLabel: { type: String, default: 'No' },
  },

  data() {
    return {
      checked: this.value,
    }
  },

  watch: {
    value(newValue) {
      this.checked = newValue
    }
  },
}
</script>

<style lang="scss">
$control-height: 1.25rem;
$control-width: 2.5rem;

.live-input--toggle {
  padding-top: 1rem;
  font-size: $font-size-sm;

  &.live-input .form-error, &.live-input .form-label {
    left: 0;
  }

  input {
    height: 0;
    width: 0;
    visibility: hidden;
    position: absolute;
  }

  label {
    cursor: pointer;
    display: block;
    position: relative;
    width: $control-width;
    height: $control-height;
    color: $danger;
    background: #f1f2f5;
    border: 1px solid #dfe1e5;
    border-radius: $control-height / 2;
    margin-top: map_get($spacers, 1);

    span {
      margin-left: calc(#{$control-width} + 7px);
      text-transform: uppercase;
      font-weight: bold;
      font-size: $font-size-xxs;
      line-height: $control-height;
      display: block;
    }

    .on {
      display: none;
    }
  }

  label:after {
    content: '×';
    text-align: center;
    line-height: $control-height - 0.1rem;
    color: white;
    position: absolute;
    top: 1px;
    left: 1px;
    width: calc(#{$control-height} - 4px);
    height: calc(#{$control-height} - 4px);
    background: $danger;
    border-radius: $control-height / 2;
    transition: 0.3s;
  }

  input:checked + label {
    color: $primary;

    &:after {
      content: '';
      background: $primary;
    }

    .on {
      display: block;
    }

    .off {
      display: none;
    }
  }

  input:checked + label:after {
    left: calc(100% - 1px);
    transform: translateX(-100%);
  }

  label:active:after {
    width: calc(#{$control-width} - 4px);
  }
}
</style>